import moment from "moment"

export const formatDate = (date: Date) => {
    return moment(date).format("DD-MMM-YYYY")
}
export const addColumnToTime = (text: string) => {
    const t = text.split('')
    return t[0] + '' + t[1] + ':' + t[2] + '' + t[3]
}
export const getHoursFromStartTime = (text: string) => {
    const t = text.split('')
    return parseInt(t[0] + '' + t[1])
}
export const getMinutesFromStartTime = (text: string) => {
    const t = text.split('')
    return parseInt(t[2] + '' + t[3])
}

export const getMonthFromNumber = (m: number) => {
    switch (m) {
        case 1:
            return "Jan"
        case 2:
            return "Feb"
        case 3:
            return "Mar"
        case 4:
            return "Apr"
        case 5:
            return "May"
        case 6:
            return "Jun"
        case 7:
            return "Jul"
        case 8:
            return "Aug"
        case 9:
            return "Sep"
        case 10:
            return "Oct"
        case 11:
            return "Nov"
        case 12:
            return "Dec"
        default:
            return ""
    }
}

//Get 12 hours from time (0000) and return format 12:00 AM/PM
export const get12HoursFromTime = (time: string) => {
    if (time.length !== 4) return "12:00 AM"
    const t = time.split('')
    let hour = parseInt(t[0] + '' + t[1])
    const minutes = t[2] + '' + t[3]
    let type = "AM"
    if (hour > 12) {
        type = "PM"
        hour -= 12
    }
    if (hour === 0) return `12:${minutes} ${type}`
    if (hour < 10) return `0${hour}:${minutes} ${type}`
    return `${hour}:${minutes} ${type}`
}